import React from 'react'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'

import {
  useQueryPaginator,
  LinkedField,
  NumberField,
  PaginatedTable,
  PalletASNField,
  RelatedListValueField,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'

import { skuit } from 'src/services/skuit'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export const PalletListPage = () => {
  const paginator = useQueryPaginator('pallet-list', skuit.client.pallets.list, {
    params: { stored: true },
  })

  const exportFields = [
    "asn",
    "bill_of_lading_number",
    "client_uid",
    "created_on",
    "facility",
    "for_shipping",
    "guid",
    "name",
    "skus",
    "total_units",
  ]
  const exportFilters = { 'stored': true }

  return (
    <React.Fragment>
      <Helmet title="Pallets" />

      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Pallets
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Typography>Pallets</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <PaginatedTable
            title="Pallets"
            fields={[
              {
                id: 'name',
                label: 'Name',
                ordering: 'container__guid',
                renderer: LinkedField(ValueField),
              },
              { id: 'clientID', label: 'Your ID', ordering: 'client_uid', renderer: ValueField },
              { id: 'skus', label: 'SKUs', ordering: 'pallet__skus__sku', renderer: RelatedListValueField('sku') },
              {
                id: 'facility',
                label: 'Facility',
                ordering: 'place__facility__name',
                renderer: RelatedLinkedField(ValueField, 'name'),
              },
              {
                id: 'asn',
                label: 'ASN',
                ordering: 'asns__tracking_number',
                renderer: PalletASNField,
              },
              {
                id: 'totalUnits',
                label: 'Total Unit Count',
                ordering: 'total_units',
                renderer: NumberField,
              },
            ]}
            paginator={paginator}
            exportConfig={{
              exportFields: exportFields,
              exportAPI: skuit.client.pallets.export,
              exportFilters: exportFilters,
            }}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
